import React, { useState, useRef, useEffect } from "react";
import openArrow from "../../../../../assets/img/openArrow.png";
import closeArrow from "../../../../../assets/img/CloseArray.png";
import PosInvoiceData from "./PosInvoiceData";

const SwipeInComponent = ({
  salesInvoiceData,
  onDragEnd,
  onClose,
  content: Content,
  isOpen: externalIsOpen,
  setIsOpen: setExternalIsOpen,
  spacing = 20, 
}) => {

  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  const setIsOpen = setExternalIsOpen || setInternalIsOpen;

  const [isDragging] = useState(false);
  const [startPosition, setStartPosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);
  const [componentWidth, setComponentWidth] = useState(750);

  const containerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const newWidth = Math.min(700, screenWidth * 0.6);
      setComponentWidth(newWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {

      if (
        !isOpen ||
        !containerRef.current ||
        containerRef.current.contains(event.target)
      ) {
        return;
      }

      const mainPOSArea = document.querySelector(".pos-maindiv");
      const productArea = document.querySelector(".products-list-container");
      const rightSection = document.querySelector(".right-section");
      const leftSection = document.querySelector(".left-section");
      const searchInput = document.querySelector(".barcode-input");
      const paymentMethod = document.querySelector(".payment-section");
      const formControls = document.querySelectorAll(
        ".form-control-borderless, .form-control-sales, input, button"
      );

      const clickedInMainInterface =
        (mainPOSArea && mainPOSArea.contains(event.target)) ||
        (productArea && productArea.contains(event.target)) ||
        (rightSection && rightSection.contains(event.target)) ||
        (leftSection && leftSection.contains(event.target)) ||
        (searchInput && searchInput.contains(event.target)) ||
        (paymentMethod && paymentMethod.contains(event.target));

      let clickedOnFormControl = false;
      formControls.forEach((control) => {
        if (control.contains(event.target)) {
          clickedOnFormControl = true;
        }
      });

      if (!clickedInMainInterface && !clickedOnFormControl) {

        handleClose();
      }
    };

    if (isOpen) {

      document.addEventListener("mousedown", handleClickOutside, true);
      document.addEventListener("touchstart", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("touchstart", handleClickOutside, true);
    };
  }, [isOpen]);

  useEffect(() => {
    const dashboardContainer = document.querySelector(".dashboard-container");
    const posTitle = document.querySelector(".pos-title");

    const totalSpaceNeeded = componentWidth + spacing;

    if (dashboardContainer) {
      if (isOpen) {

        dashboardContainer.style.width = `calc(100% - ${totalSpaceNeeded}px)`;
        dashboardContainer.style.marginRight = `${totalSpaceNeeded}px`;
        dashboardContainer.style.transition =
          "width 0.3s ease-in-out, margin-right 0.3s ease-in-out";

        if (posTitle) {
          posTitle.style.display = "none";
        }

        const posHeading = document.querySelector(".pos-maindiv h6");
        if (posHeading && posHeading.textContent.includes("Point of Sale")) {
          posHeading.style.display = "none";
        }
      } else {

        dashboardContainer.style.width = "100%";
        dashboardContainer.style.marginRight = "0";

        if (posTitle) {
          posTitle.style.display = "block";
        }

        const posHeading = document.querySelector(".pos-maindiv h6");
        if (posHeading && posHeading.textContent.includes("Point of Sale")) {
          posHeading.style.display = "block";
        }
      }
    }
  }, [isOpen, componentWidth, spacing]);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
    onDragEnd?.(false);
  };

  const handleMouseDown = (event) => {

    setStartPosition(event.clientX);
    event.preventDefault();
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;

    const distanceMoved = event.clientX - startPosition;
    setCurrentPosition(distanceMoved);

    if (containerRef.current) {
      containerRef.current.style.transform = `translateX(${
        isOpen
          ? Math.min(distanceMoved, 0)
          : Math.max(distanceMoved, -(componentWidth - 20))
      }px)`;
    }
  };

  const handleMouseUp = () => {
    if (!isDragging) return;

    const movedDistance = currentPosition;
    const triggerThreshold = componentWidth * 0.2; 

    if (!isOpen && movedDistance > triggerThreshold) {
      setIsOpen(true);
      onDragEnd?.(true);
    } else if (isOpen && movedDistance < -triggerThreshold) {
      handleClose();
    }

    if (containerRef.current) {
      containerRef.current.style.transform = isOpen
        ? "translateX(0)"
        : `translateX(${componentWidth - 20}px)`; 
    }

    setCurrentPosition(0);
  };

  const handleTouchStart = (event) => {
    handleMouseDown(event.touches[0]);
  };

  const handleTouchMove = (event) => {
    handleMouseMove(event.touches[0]);
  };

  const handleTouchEnd = () => {
    handleMouseUp();
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.transform = isOpen
        ? "translateX(0)"
        : `translateX(${componentWidth - 20}px)`; 
    }
  }, [isOpen, componentWidth]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        pointerEvents: "none",
      }}
    >
      <div
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        ref={containerRef}
        style={{
          position: "fixed",
          width: `${componentWidth}px`,
          maxHeight: "80vh", 
          right: "0",
          top: "120px", 
          backgroundColor: "#FFFFFF",
          borderRadius: "20px 0px 0px 20px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          transition: isDragging ? "none" : "transform 0.3s ease-in-out",
          transform: `translateX(${isOpen ? 0 : componentWidth - 20}px)`, 
          display: "flex",
          flexDirection: "column",
          pointerEvents: "all",
        }}
      >
        {}
        <div
          style={{
            position: "absolute",
            width: "37px",
            height: "150px",
            left: "-37px",
            border: "1px solid #E3E3E3",
            top: "calc(50% - 50px)",
            backgroundColor: "#FFFFFF",
            borderRadius: "10px 0px 0px 10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            flexDirection: "row", 
            writingMode: "sideways-lr",
            textOrientation: "mixed",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#000",
            padding: "5px",
            gap: "8px", 
          }}
          onClick={(e) => {
            setIsOpen(!isOpen);
          }}
        >
          <span style={{ fontWeight: "bold" }}>Transactions</span>
          <img
            src={isOpen ? closeArrow : openArrow}
            alt="Toggle sidebar"
            style={{
              width: "15px",
              height: "15px",
              transform: "rotate(0deg)", 
            }}
          />
        </div>

        <div
          style={{
            flex: 1,
            width: "100%",
            padding: "20px",

            overflowY: "auto",
            minHeight: "640px", 
            maxHeight: "calc(80vh - 120px)", 
          }}
        >
          {Content ? (
            <Content />
          ) : (
            <>
              <h4
                style={{
                  fontSize: "36px",
                  marginLeft: "10px",
                  
                  // marginBottom: "20px",
                }}
              >
                Recent Invoice
              </h4>
             
            </>
          )}
          <div style={{ marginLeft: "10px", width: "100%" }}>
            <PosInvoiceData salesInvoiceData={salesInvoiceData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwipeInComponent;